import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { LOADS_SOURCING } from './actions';
import {
	BID_SOURCE_TYPE,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
} from 'cargo-chief-commons';

export const reducers = createReducer(
	initialState,
	on(LOADS_SOURCING.CARRIER.CARRIER_ID_SUCCESS, (state, action: any) => ({
		...state,
		carrierId: action.carrierId,
	})),
	on(LOADS_SOURCING.ACCOUNT.ID_SUCCESS, (state, action: any) => ({
		...state,
		accountId: action.accountId,
	})),
	on(LOADS_SOURCING.ACCOUNT.LOGO_SUCCESS, (state, action: any) => ({
		...state,
		accountLogoUrl: action.accountLogoUrl,
	})),
	on(LOADS_SOURCING.ACCOUNT.BUSINESS_NAME, (state, action: any) => ({
		...state,
		businessName: action.businessName,
	})),
	on(LOADS_SOURCING.LOADS_LIST.PAGE, (state, action: any) => ({
		...state,
		currentPage: action.currentPage,
	})),
	on(LOADS_SOURCING.LOADS_LIST.PAGE_SIZE, (state, action: any) => ({
		...state,
		pageSize: action.pageSize,
	})),

	on(LOADS_SOURCING.CARRIER.SUCCESS, (state, action: any) => ({
		...state,
		carrier: action.data,
	})),

	on(LOADS_SOURCING.LOADS_LIST.GET, (state) => ({
		...state,
		loading: true,
		countOfBidsBeingAdded: 0,
	})),
	on(LOADS_SOURCING.LOADS_LIST.GET_AVAILABLE, (state) => ({
		...state,
		loading: true,
		countOfBidsBeingAdded: 0,
	})),
	on(LOADS_SOURCING.LOADS_LIST.GET_BOOKED, (state) => ({
		...state,
		loading: true,
		countOfBidsBeingAdded: 0,
	})),
	on(LOADS_SOURCING.LOADS_LIST.GET_BATCH, (state) => ({
		...state,
		loading: true,
		countOfBidsBeingAdded: 0,
	})),
	on(LOADS_SOURCING.LOADS_LIST.SUCCESS, (state, action: any) => ({
		...state,
		loading: false,
		loadsList: action.data,
		loadsListCopy: action.data,
		total: action.total_elements,
		apiMessage: action.message || null,
	})),
	on(LOADS_SOURCING.LOADS_LIST.SET_FILTER, (state, action: any) => ({
		...state,
		equipment: action.equipment,
		originState: action.originState,
		batchId: action.batchId,
	})),
	on(LOADS_SOURCING.LOADS_LIST.SET_LOAD_TYPE, (state, action: any) => ({
		...state,
		loadType: action.loadType,
	})),
	on(LOADS_SOURCING.LOADS_LIST.SORT, (state, action: { sortList: any[] }) => ({
		...state,
		sort: action.sortList,
	})),
	on(LOADS_SOURCING.LOADS_LIST.FILTER_LIST, (state, action: { filtersList: any[] }) => ({
		...state,
		filters: action.filtersList,
	})),
	on(LOADS_SOURCING.LOADS_LIST.CLIENT_FILTER_SUCCESS, (state, action: { data: any[] }) => ({
		...state,
		loadsList: action.data,
	})),
	on(LOADS_SOURCING.LOADS_LIST.UPDATE, (state, action: { updatedLoad: any }) => ({
		...state,
		loadsList: state.loadsList.map((load) =>
			load.id === action.updatedLoad.id ? action.updatedLoad : load
		),
	})),
	on(LOADS_SOURCING.OFFER.DIALOG_LOAD_SUCCESS, (state, action: any) => ({
		...state,
		loadsList: state.loadsList.map((loadRaw) => {
			let load = Object.assign({}, loadRaw);
			if (action.id === load.id) {
				load.offerSent = true;
			}
			return load;
		}),
		successfulLoads: [...state.successfulLoads, action],
		offerSubmitted: true,
	})),
	on(LOADS_SOURCING.OFFER.DIALOG_LOAD_FAILURE, (state, action: any) => ({
		...state,
		unsuccessfulLoads: [...state.unsuccessfulLoads, action],
	})),
	on(LOADS_SOURCING.OFFER.DIALOG_RATE_CHANGE, (state, action: any) => ({
		...state,
		currentRateSelection: action.rate,
	})),
	on(LOADS_SOURCING.LOADS_LIST.FAILURE, (state, action) => ({
		...state,
		loading: false,
		error: action.payload.message,
		countOfBidsBeingAdded: 0,
	})),
	on(LOADS_SOURCING.OFFER.OPEN_DIALOG, (state, action: any) => ({
		...state,
		offerDialogOpen: true,
	})),
	on(LOADS_SOURCING.OFFER.CLOSE_DIALOG, (state, action: any) => ({
		...state,
		unsuccessfulLoads: [],
		successfulLoads: [],
		currentRateSelection: null,
		offerDialogOpen: false,
	})),

	// set state data
	on(LOADS_SOURCING.SET.COMPANY_LIST, (state, action: any) => ({
		...state,
		companyList: action.accountsList,
	})),

	on(LOADS_SOURCING.RESET_STATE, (state) => ({
		...initialState,
	})),

	on(LOADS_SOURCING.SET.OPEN_LOADS, (state, action: any) => ({
		...state,
		showOpenLoads: action.showOpenLoads,
	})),

	// on websocket notification updates
	on(LOADS_SOURCING.WEBSOCKET_NOTIFICATIONS.BROKER_COUNTERED, (state, action: any) => ({
		...state,
		loadsList: state.loadsList.map((loadRaw) => {
			if (action.bidId !== loadRaw?.bidDTO?.id) {
				return loadRaw;
			}
			return updateLoadWithBrokerCounter(loadRaw, action);
		}),
	})),

	on(LOADS_SOURCING.WEBSOCKET_NOTIFICATIONS.SELECTED, (state, action: any) => ({
		...state,
		loadsList: [...state.loadsList].filter((load) => load?.bidDTO?.id !== action.bidId),
	})),
	on(
		LOADS_SOURCING.SET.COUNT_OF_BIDS_BEING_ADDED,
		(state, action: { countOfBidsBeingAdded: number }) => ({
			...state,
			countOfBidsBeingAdded: action.countOfBidsBeingAdded,
		})
	),

	on(LOADS_SOURCING.OFFER.BID_SUBMIT_SUCCESS, (state, action: any) => {
		const resp = action ?? {};
		const respBidId = resp.id ?? resp?.bidDTO?.id;
		const respQuoteId = resp.quoteId ?? resp?.bidDTO?.quoteId ?? resp?.quoteDTO?.id;

		const loadsList = (state.loadsList || []).map((load: any) => {
			const loadBidId = load?.bidDTO?.id;
			const loadQuoteId = load?.bidDTO?.quoteId ?? load?.quoteDTO?.id;

			const isTarget =
				(!!respBidId && loadBidId === respBidId) || (!!respQuoteId && loadQuoteId === respQuoteId);

			if (!isTarget) return load;

			// 1) update ONLY bidHistories
			const newBidHistories: any[] = Array.isArray(resp.bidHistories)
				? resp.bidHistories
				: load?.bidDTO?.bidHistories ?? [];

			const newBidDTO = {
				...(load.bidDTO ?? {}),
				bidHistories: newBidHistories,
			};

			// 2) recompute derived fields per your logic
			const bidHistoriesList = [...newBidHistories].sort(
				(a, b) => new Date(a?.created ?? 0).getTime() - new Date(b?.created ?? 0).getTime()
			);

			// CN-8952: rate-bearing rows only. Non-rate actions (viewed/contacted/cancelled/declined)
			// record a null amount, and taking the newest row of a source type without this filter
			// blanks the displayed rate. The companion fix landed in effects.ts but missed here.
			const carrierHist = bidHistoriesList.filter(
				(h) => h?.sourceType !== BID_SOURCE_TYPE.CUSTOMER && h?.amount != null
			);
			const customerHist = bidHistoriesList.filter(
				(h) => h?.sourceType === BID_SOURCE_TYPE.CUSTOMER && h?.amount != null
			);

			const offeredRate =
				carrierHist.length > 0 ? carrierHist[carrierHist.length - 1].amount : load.offeredRate;

			const rate =
				customerHist.length > 0
					? customerHist[customerHist.length - 1].amount
					: load?.quoteDTO?.desiredPrice ?? load?.bidDTO?.amount ?? load.rate;

			return {
				...load,
				bidDTO: newBidDTO,
				offeredRate,
				rate,
			};
		});

		return {
			...state,
			loadsList,
		};
	}),

	// on carrier declining booked load
	on(LOADS_SOURCING.DECLINE_OFFER.DECLINE, (state, action: any) => ({
		...state,
		isDeclineOfferRequestInProgress: true,
	})),
	on(LOADS_SOURCING.DECLINE_OFFER.SUCCESS, (state, action: any) => {
		const declinedIds = action.loadsList.map((bid: any) => bid.id);
		return {
			...state,
			loadsList: state.loadsList.filter((load: any) => !declinedIds.includes(load?.bidDTO?.id)),
			isDeclineOfferRequestInProgress: false,
		};
	}),
	on(LOADS_SOURCING.DECLINE_OFFER.FAILURE, (state, action: any) => ({
		...state,
		isDeclineOfferRequestInProgress: false,
	})),

	// Add single load from WebSocket INVITED notification
	on(LOADS_SOURCING.LOADS_LIST.ADD_LOAD_TO_LIST, (state, { load }) => {
		// Check if load already exists (by load ID)
		const existingIndex = state.loadsList.findIndex((l) => l.id === load.id);

		if (existingIndex >= 0) {
			// Update existing load
			const updatedList = [...state.loadsList];
			updatedList[existingIndex] = load;

			// Also update loadsListCopy to maintain filter consistency
			const updatedListCopy = [...state.loadsListCopy];
			const existingCopyIndex = updatedListCopy.findIndex((l) => l.id === load.id);

			if (existingCopyIndex >= 0) {
				updatedListCopy[existingCopyIndex] = load;
			}

			return {
				...state,
				loadsList: updatedList,
				loadsListCopy: updatedListCopy,
			};
		} else {
			// Add new load to beginning of list
			const newLoadsList = [load, ...state.loadsList];

			return {
				...state,
				loadsList: newLoadsList,
				loadsListCopy: newLoadsList,
				total: state.total + 1,
			};
		}
	})
);

const updateLoadWithBrokerCounter = (load: any, action: any) => {
	const existingBidHistories = load.bidDTO?.bidHistories || [];
	const newBidHistoryEntry = {
		amount: action.amount,
		bidId: load.bidDTO.id,
		carrierId: null,
		contactId: null,
		created: new Date(),
		pickupDate: action.pickupDate,
		deliveryDate: action.deliveryDate,
		sourceType: BID_SOURCE_TYPE.CUSTOMER,
	};

	const updatedBidHistories = [...existingBidHistories, newBidHistoryEntry].sort(
		(a, b) => new Date(a.created).getTime() - new Date(b.created).getTime()
	);
	// CN-8952: rate-bearing rows only — see the note in the BID_SUBMIT_SUCCESS handler above.
	const customerBids = updatedBidHistories.filter(
		(b) => b.sourceType === BID_SOURCE_TYPE.CUSTOMER && b.amount != null
	);
	const brokerBids = updatedBidHistories.filter(
		(b) => b.sourceType !== BID_SOURCE_TYPE.CUSTOMER && b.amount != null
	);

	return {
		...load,
		offerSent: false,
		bidDTO: {
			...load.bidDTO,
			bidHistories: updatedBidHistories,
		},
		offeredRate:
			brokerBids.length > 0 ? brokerBids[brokerBids.length - 1].amount : load.offeredRate,
		rate:
			customerBids.length > 0 ? customerBids[customerBids.length - 1].amount : load.bidDTO.amount,
	};
};
